import React, { PureComponent } from "react";
import { Map, List, fromJS } from "immutable";
import { injectIntl, defineMessages } from "react-intl";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as common from "libs/commonFunc";
import * as eduTemplateActions from "modules/eduTemplate";

import { EduTemplateList } from "components";

class CtEduTemplateList extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      fromNowView: false,
      fitRowCount: 0,
      currentPage: 0,
      pageSize: 0,
      searchType: "searchAll",
      tempFilter: {},
      searchValue: "",
    };
  }

  componentWillMount() {
    // 화면 사이즈(높이)에 해당하는 리스트의 개수 설정
    let fitRowCount = Math.trunc((window.innerHeight - 315) / 48);
    fitRowCount = fitRowCount < 5 ? 5 : fitRowCount;

    this.handleInitFilter();
    this.setState({ pageSize: fitRowCount, fitRowCount });
  }

  componentDidUpdate(prevProps) {
    const { needReload, paramData, examSummary } = this.props;
    if (
      needReload !== prevProps.needReload ||
      // parameter가 변경되었을때
      paramData !== prevProps.paramData ||
      // 훈련 실시했을 때
      examSummary !== prevProps.examSummary
    ) {
      this.getEduTemplate();
    }
  }

  // 교육 템플릿 리스트 조회
  getEduTemplate = async () => {
    if (!this.state.loading) {
      this.setState({ loading: true });

      try {
        const { EduTemplateActions, paramData } = this.props;
        const { currentPage, pageSize } = this.state;
        const params = {
          filter: JSON.stringify(paramData.get("filter")),
          sort: JSON.stringify(paramData.get("sort")),
          offset: pageSize * (currentPage < 0 ? 0 : currentPage), // page 는 0 번 부터 시작
          limit: pageSize < 1 ? 20 : pageSize,
        };

        await EduTemplateActions.getEduTemplate(params);
      } catch (e) {
        console.log(e);
      }

      this.setState({ loading: false });
    }
  };

  // 필터 처리
  // 정렬 처리
  handleFetchData = ({ ...rest }) => {
    const { sorted } = rest;
    const sort = [];
    if (sorted && Array.isArray(sorted)) {
      // 정렬이 적용됨
      for (let i = 0; i < sorted.length; i++) {
        const data = sorted[i];
        sort.push({ field: data.id, order: data.desc ? "DESC" : "ASC" });
      }
    }

    const { EduTemplateActions } = this.props;
    EduTemplateActions.changeParam({
      name: "sort",
      value: fromJS(sort),
    });
  };

  // 검색 타입 선택
  handleSearchOptions = (e, { value }) => {
    this.setState({ searchType: value });
  };

  // 검색어 입력
  handleChangeSearch = (e) => {
    this.setState({ searchText: e.target.value });
  };

  // 검색
  handleOnSearch = (e) => {
    const { searchValue, searchType, tempFilter } = this.state;
    const { EduTemplateActions, paramData } = this.props;

    if (e.key === "Enter" || e.target.id === "bt-search-input" || e.target.parentNode.id === "bt-search-input" || e.target.parentNode.parentNode.id === "bt-search-input") {
      const filter = paramData.get("filter").toJS();
      if (searchValue !== filter[searchType]) {
        // 검색 타입 제거
        const searchOptions = ["searchAll", "eduAttachNo", "attachName", "fileCount"];
        searchOptions.map((option) => delete filter[option]);

        if (!!searchValue) {
          filter[searchType] = searchValue;
        }

        this.setState({ currentPage: 0 });
        EduTemplateActions.changeParam({
          name: "filter",
          value: fromJS(filter),
        });
      }
    }
  };

  // 날짜 필터
  handleChangeDateFilter = (type, data) => {
    const { EduTemplateActions, paramData } = this.props;
    const filter = paramData.get("filter").toJS();

    if (data.startDate) {
      filter["start" + type] = data.startDate;
    }
    if (data.endDate) {
      filter["end" + type] = data.endDate;
    }

    this.setState({ currentPage: 0 });
    EduTemplateActions.changeParam({
      name: "filter",
      value: fromJS(filter),
    });
  };

  // 필터 초기화
  handleInitFilter = () => {
    const { EduTemplateActions } = this.props;

    EduTemplateActions.changeParam({
      name: "filter",
      value: Map({}),
    });

    if (this.myTextInput && this.myTextInput.inputRef.value !== "") {
      this.myTextInput.inputRef.value = "";
    }

    this.setState({ searchType: "searchAll", searchText: "", searchValue: "", tempFilter: {} });
  };

  // 페이지 이동 처리
  handlePagination = (pageNo) => {
    this.setState({ currentPage: pageNo });
  };

  // 페이지 개수 처리 (페이지 초기화)
  handlePageSizeOnChange = (obj, value) => {
    this.setState({ pageSize: value.value, currentPage: 0 });
  };

  // 검색 입력값 받아오기
  takeSearchValue = (value) => {
    this.setState({
      searchValue: value,
    });
  };

  searchTextRef = (ref) => {
    this.myTextInput = ref;
  };

  //필터 팝업 클로즈
  filterClose = () => {
    const { paramData } = this.props;
    const filter = paramData.get("filter").toJS();

    this.setState({
      tempFilter: filter,
      isLoading: false,
    });
  };

  //체크한 필터 실행
  executeFilter = () => {
    const { EduTemplateActions, paramData } = this.props;
    const { tempFilter, searchType, searchValue } = this.state;
    const filter = tempFilter;

    // 검색 타입 제거
    const searchOptions = ["searchAll", "eduAttachNo", "attachName", "fileCount"];
    searchOptions.map((option) => delete filter[option]);
    if (!!searchValue) {
      filter[searchType] = searchValue;
    }

    const paramFilter = paramData.get("filter").toJS();
    if (paramFilter["startRegEpoch"]) {
      filter["startRegEpoch"] = paramFilter["startRegEpoch"];
    }
    if (paramFilter["endRegEpoch"]) {
      filter["endRegEpoch"] = paramFilter["endRegEpoch"];
    }

    this.setState({ currentPage: 0 });
    EduTemplateActions.changeParam({
      name: "filter",
      value: fromJS(filter),
    });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const { loading, fromNowView, currentPage, pageSize, fitRowCount, searchType, searchText, tempFilter } = this.state;
    const { isAuth, templateData, totalPages, totalCount, paramData } = this.props;
    const { handleFetchData } = this;
    // 검색
    const { handleSearchOptions, handleChangeSearch, handleOnSearch, handleChangeDateFilter, handleInitFilter, takeSearchValue, searchTextRef, filterClose, executeFilter } = this;
    // 페이징
    const { handlePagination, handlePageSizeOnChange } = this;

    const filterData = paramData.get("filter").toJS();
    let respData = {};
    if (templateData && Map.isMap(templateData)) {
      respData = templateData.toJS();
    }

    const pageSizeArray = common.ArraySort(common.ArrayDuplicateRemove([5, 10, 20, 25, 50, 100, fitRowCount]));
    const pageSizeOptions = [];
    pageSizeArray.map((value) => {
      pageSizeOptions.push({ text: value, value: value });
    });

    const searchOptions = [
      {
        key: 0,
        text: defineMessages(formatMessage({ id: "Faq_1", defaultMessage: "전체" })),
        value: "searchAll",
      },
      {
        key: 1,
        text: defineMessages(formatMessage({ id: "PhishingTemplateList_11", defaultMessage: "No" })),
        value: "eduAttachNo",
      },
      {
        key: 2,
        text: defineMessages(formatMessage({ id: "EduTemplate_1", defaultMessage: "컨텐츠명" })),
        value: "attachName",
      },
      {
        key: 3,
        text: defineMessages(formatMessage({ id: "EduTemplate_4", defaultMessage: "영상명" })),
        value: "fileName",
      },
    ];

    return (
      <EduTemplateList
        isAuth={isAuth}
        fromNowView={fromNowView}
        manual
        data={respData.success}
        totalCount={totalCount}
        page={currentPage}
        pages={totalPages}
        pageSize={pageSize}
        defaultPageSize={fitRowCount}
        pageSizeOptions={pageSizeOptions}
        loading={loading}
        onFetchData={handleFetchData}
        // 검색 영역
        searchObj={{
          filterData: filterData,
          currentPage: currentPage,
          pageSize: pageSize,
          totalCount: totalCount,
          searchType: searchType,
          searchText: searchText,
          searchOptions: searchOptions,
          handleSearchOptions: handleSearchOptions,
          handleChangeSearch: handleChangeSearch,
          handleOnSearch: handleOnSearch,
          handleInitFilter: handleInitFilter,
          defaultPageSize: fitRowCount,
          pageSizeOptions: pageSizeOptions,
          handlePageSizeOnChange: handlePageSizeOnChange,
          takeSearchValue: takeSearchValue,
          searchTextRef: searchTextRef,
          paramData: paramData,
          tempFilter: tempFilter,
        }}
        // 필터
        filterClose={filterClose}
        executeFilter={executeFilter}
        handleChangeDateFilter={handleChangeDateFilter}
        // 페이징 처리
        handlePagination={handlePagination}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    templateData: state.eduTemplate.get("data"),
    needReload: state.eduTemplate.get("needReload"),
    totalPages: state.eduTemplate.get("totalPages"),
    totalCount: state.eduTemplate.get("totalCount"),
    paramData: state.eduTemplate.get("param"),
    isAuth: state.user.get("isAuth"),
  };
};

const mapDispatchToProps = (dispatch) => ({
  EduTemplateActions: bindActionCreators(eduTemplateActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtEduTemplateList));



// WEBPACK FOOTER //
// ./src/script/containers/eduTemplate/CtEduTemplateList.js